import { useState, useEffect } from "react";
import { getProjectStats } from "../../backend-services";
import { ProjectStatsData } from "../../@types/project";

export function useProjectStatsData(startDate: Date, endDate: Date) {
  const [projectData, setProjectData] = useState<ProjectStatsData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fetchData = async () => {
    try {
      const response = await getProjectStats(
        startDate.toISOString(),
        endDate.toISOString(),
      );

     
      setProjectData(response);
      setError(null);
    } catch (error) {
      setError("Failed to fetch expense statistics");
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return { projectData, error, fetchProjectStat: fetchData };
}
